// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1zj7Q","footer":"ModalFilter_footer__1yxzG"};